import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { PaintDirective } from '../../../paint.directive';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'coupon-guide',
  templateUrl: './coupon-guide.component.html',
  styleUrls: ['./coupon-guide.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, PaintDirective, RouterLink]
})
export default class CouponGuideComponent {

}
